var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskInspectionTaxiway = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#task-inspection-taxiway_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m16.364 16.68-5.237-3.321-1.054 3.992 1.147 1.477-.285 1.081-2.31-1.374-2.67.059.286-1.08 1.693-.728 1.054-3.992-6.16.312.377-1.429L9.85 9.534l1.054-3.992q.12-.453.51-.685a1.07 1.07 0 0 1 .853-.11q.462.12.679.514.216.393.097.846L11.988 10.1l4.753 5.153-.377 1.429z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.75 8.894V24h-1.5V8.894A9.75 9.75 0 0 1 24 0v1.677a8.25 8.25 0 0 0-4.25 7.217m-18.25 0V24H0V8.894A9.75 9.75 0 0 1 5.75 0v1.677A8.25 8.25 0 0 0 1.5 8.894"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "task-inspection-taxiway_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h24v24H0z"
})))));
export default SvgTaskInspectionTaxiway;